import type { Article } from '@b2ag/articles/src/domain/Article'
import { getBrandName } from '@b2ag/app-brands'

export function mapArticleMetaInfo(
  article: Article,
  articleUrl: string,
  links: { href: string; hreflang: string; rel: string }[],
) {
  const title = article?.seo?.title || article.title
  const description = article?.seo?.description || article.summary
  const imageUrl = article?.header?.image
  const brandName = getBrandName()

  const infos = {
    title,
    titleTemplate: `%s | ${brandName}`,
    meta: [
      { property: 'og:title', content: `${article.title} | ${brandName}` },
      { property: 'og:type', content: 'article' },
      { property: 'og:url', content: articleUrl },
      { property: 'twitter:card', content: 'summary_large_image' },
      { property: 'twitter:creator', content: `@${brandName}` },
      { property: 'twitter:site', content: `@${brandName}` },
    ],
  } as {
    title: string
    titleTemplate: string
    meta: { vmid?: string; name?: string; property?: string; content: string }[]
    link: { rel: string; href: string; hreflang: string }[]
  }
  if (links) {
    infos.link = links
  }

  if (description) {
    infos.meta?.push({ vmid: 'description', name: 'description', content: description })
  }

  if (article.summary) {
    infos.meta?.push({ property: 'og:description', content: article.summary })
  }

  if (imageUrl) {
    infos.meta?.push({ property: 'og:image', content: imageUrl })
    infos.meta?.push({ property: 'twitter:image:src', content: imageUrl })
  }

  return infos
}
